import {ReactComponent as ClockIcon} from './clock.svg'

function Clock() {
  return <ClockIcon />
}

export default Clock
